import { environment } from '@environments/environment';
import { DateTime } from 'luxon';

export enum SeatClass {
  premium = 'Premium',
  economy = 'Economy',
}

export enum PassengerType {
  child = 'Child',
  adult = 'Adult',
}

export enum PassengerTypeCode {
  adult = 'ADT',
  child = 'CHD',
  infant = 'INF',
}

export enum TripType {
  oneWay = 'oneWay',
  roundTrip = 'roundTrip',
  multiCity = 'multiCity',
}

// Traveler picker consts - Navitaire max PAX config = 999
export const ADULT_MIN_COUNT = 0;
export const ADULT_MAX_COUNT = 20;
export const CHILD_MIN_COUNT = 0;
export const CHILD_MAX_COUNT = 20;
export const INFANT_MIN_COUNT = 0;
export const MAX_TRAVELER_COUNT = 20;

// Search widget constants
export const TODAY_PLUS_ONE_DAY = DateTime.now().plus({ days: 1 }).toJSDate();
export const DEFAULT_MIN_DATE =
  DateTime.fromISO(environment.firstFlightDate).toJSDate() >
  DateTime.now().toJSDate()
    ? DateTime.fromISO(environment.firstFlightDate).toJSDate()
    : DateTime.now().toJSDate();
export const DEFAULT_MAX_DATE = DateTime.now().plus({ years: 1 }).toJSDate();
export const MULTI_CITY_MAX_TRIP_COUNT = 2;
